import { render, staticRenderFns } from "./q5.vue?vue&type=template&id=f57ef0d4&"
import script from "./q5.vue?vue&type=script&lang=js&"
export * from "./q5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports